// Cart drawer open/close state — module-level store so any component can open
// the drawer (header icon, "added to cart" toast, etc.) without prop-drilling.
//
// Why a separate module from cart-store: the cart's contents live in Wix and
// are shared across tabs; the drawer's open state is purely local UI for THIS
// tab. Mixing them would force the drawer logic into the cross-tab sync flow
// and confuse the responsibilities.

'use client';

import { useSyncExternalStore } from 'react';

let isOpen = false;
const listeners = new Set<() => void>();

function emit() {
  for (const fn of listeners) fn();
}

export function openCartDrawer(): void {
  if (isOpen) return;
  isOpen = true;
  emit();
}

export function closeCartDrawer(): void {
  if (!isOpen) return;
  isOpen = false;
  emit();
}

function subscribe(fn: () => void): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

function getSnapshot(): boolean {
  return isOpen;
}

function getServerSnapshot(): boolean {
  return false;
}

export function useCartDrawer(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
